var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.option.key,
    class: [_vm.$style.container, (_ref = {}, _ref[_vm.$style.active] = _vm.active, _ref)],
    on: {
      "click": function click($event) {
        return _vm.$emit('click', $event);
      }
    }
  }, [_c('div', {
    class: _vm.$style.icon
  }, [_vm.active ? _c('cs-icon', {
    attrs: {
      "name": _vm.option.icon,
      "color": "#fff"
    }
  }) : _c('cs-icon', {
    attrs: {
      "name": _vm.option.icon,
      "color": "#212121"
    }
  })], 1), _c('div', {
    class: _vm.$style.help
  }, [_vm.active ? _c('help-link', {
    attrs: {
      "source": _vm.option.help
    }
  }) : _vm._e()], 1), _c('div', {
    class: _vm.$style.label,
    domProps: {
      "textContent": _vm._s(_vm.$t(_vm.option.label))
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }